import { render, staticRenderFns } from "./pouch.vue?vue&type=template&id=5d5cd4fc&scoped=true"
import script from "./pouch.vue?vue&type=script&lang=js"
export * from "./pouch.vue?vue&type=script&lang=js"
import style0 from "./pouch.vue?vue&type=style&index=0&id=5d5cd4fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5cd4fc",
  null
  
)

export default component.exports